import './creditCardList.scss';

export const CreditCardList = angular
    .module('checkout.components.creditCardList', [])
    .component('creditCardList', {
        template: `
            <div layout layout-align="start center">
                <credit-card-image card-type="'mastercard'"></credit-card-image>
                <credit-card-image card-type="'visa'"></credit-card-image>
                <credit-card-image card-type="'discover'"></credit-card-image>
                <credit-card-image card-type="'amex'"></credit-card-image>
            </div>
        `,
        bindings: {
            cardType: '<'
        }
    }).name;



// WEBPACK FOOTER //
// ./src/app/components/creditCardList/creditCardList.js